/**
 * @file masonry layout functions
 * @author tobias.frei@notch-interactive.com
 *
 * @module components/calendar/calendar-layout.js
 */

import model from './filter-model';

const instance = {};


/**
 * change layout mode
 *
 * @return {void}
 */
instance.changeLayout = () => {

    // Close all open tiles
    model.calendar.closeAllTiles();

    window.requestAnimationFrame(function () {

        // Get actual layout mode
        if (model.calendar.currentLayout.layoutMode === 'vertical') {

            // Write current layout to localStorage
            if (typeof(Storage) !== undefined) {
                localStorage.setItem('calendar-current-layout', 'tiles');
            }

            // Remove list flag
            model.calendar.listview = false;

            // Set mode to fit rows
            model.calendar.$refs.cpt.layout('fitRows');

            // Scope calendar
            let that = model.calendar;

            window.requestAnimationFrame(function () {

                // Call sort cmd
                that.$refs.cpt.sort(model.calendar.option.sortBy);

                // Wait for layout change and set tile style (odd/even)
                window.requestAnimationFrame(function () {
                    that.setTileStyles();
                });
            });

        } else {

            // Write current layout to localStorage
            if (typeof(Storage) !== undefined) {
                localStorage.setItem('calendar-current-layout', 'list');
            }

            // Set list flag
            model.calendar.listview = true;

            // Scope calendar
            let that = model.calendar;

            window.requestAnimationFrame(function () {

                // Set layout to vertical list
                that.$refs.cpt.layout('vertical');

                // Wait for layout change and set tile style (odd/even)
                window.requestAnimationFrame(function () {
                    that.setTileStyles();
                });
            });
        }
    });
};


/**
 * sort isotope
 *
 * @return {void}
 */
instance.sort = () => {
    model.calendar.$refs.cpt.sort(model.calendar.option.sortBy);
};


export default instance;
